import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultMembershipContent } from '../../siteContent';
import { useCms, Text } from './cmsShared';

const AdminContentMembership = () => {
  const { content, update, save, saving } = useCms('membership', defaultMembershipContent);
  const c = content;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="font-heading text-xl font-bold text-[#003366]">Membership Page — Content</h2>
          <p className="text-sm text-gray-500">Edit hero and contribution section text. Form fields and skill chips are code-managed.</p>
        </div>
        <Button onClick={save} disabled={saving} data-testid="cms-membership-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>

      <Accordion type="multiple" defaultValue={['hero', 'contribution']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Hero Section</AccordionTrigger>
          <AccordionContent>
            <Text label="Badge text" value={c.hero.badge} onChange={(v) => update(['hero', 'badge'], v)} />
            <div className="grid grid-cols-2 gap-3">
              <Text label="Heading prefix" value={c.hero.heading} onChange={(v) => update(['hero', 'heading'], v)} />
              <Text label="Heading highlight (shown in red)" value={c.hero.headingHighlight} onChange={(v) => update(['hero', 'headingHighlight'], v)} />
            </div>
            <Text label="Subtext" value={c.hero.subtext} onChange={(v) => update(['hero', 'subtext'], v)} area />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="contribution" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Contribution Section (navy band)</AccordionTrigger>
          <AccordionContent>
            <Text label="Eyebrow" value={c.contributionSection.eyebrow} onChange={(v) => update(['contributionSection', 'eyebrow'], v)} />
            <Text label="Heading" value={c.contributionSection.heading} onChange={(v) => update(['contributionSection', 'heading'], v)} area />
            <Text label="Subtext" value={c.contributionSection.subtext} onChange={(v) => update(['contributionSection', 'subtext'], v)} area />
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="flex justify-end mt-6">
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>
    </div>
  );
};

export default AdminContentMembership;
